import { color, fontSize, MixinStyle } from '@license-admin/boldjobs';
import { device } from '@styles/device.styled';
import Mixin from '@styles/mixin';
import styled, { css } from 'styled-components';

export const Select = styled.select<{
  isArrowFill?: boolean;
  $borderRight?: boolean;
  $isSearchFilter?: boolean;
  $isborderRight?: boolean;
  $isRCPortal?: boolean;
  $isCountryLocation?: boolean;
}>`
  padding: 0.6rem 3.6rem 0.6rem 1.2rem;
  border-radius: ${({ $borderRight }) => !$borderRight && '0.4rem'};
  display: block;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-size: 1em;
  background-repeat: no-repeat;
  background-position: right 1rem center;
  width: 100%;
  ${({ theme: { FormControlStyle } }) =>
    FormControlStyle &&
    css`
      border: 0.1rem solid ${FormControlStyle.BdrColors.select};
      color: ${FormControlStyle.Colors.DarkColor};
    `};
  ${({
    $isSearchFilter,
    $isborderRight,
    $isRCPortal,
    theme: { FormControlStyle },
  }) =>
    $isSearchFilter &&
    css`
      ${$isborderRight
        ? css`
            height: 3.86rem;
            border-radius: 0 0.3rem 0.3rem 0;
            border: 0.1rem solid ${FormControlStyle?.BdrColors?.selectCountry};
            border-left: 0;
          `
        : css`
            height: 3.7rem;
            border-right: 0;
          `}
      ${!$isRCPortal &&
      css`
        ${device.tabletMd} {
          height: 3.4rem;
        }
      `}
    `}
  ${({ $isCountryLocation }) =>
    $isCountryLocation &&
    css`
      ${device.mobileLg} {
        height: ${$isCountryLocation ? '4.8rem' : null};
      }
    `};
`;

interface InputSearchProp {
  $bdrcurve?: boolean;
  $inputHeight?: string;
  $isHeader?: boolean;
  $borderRight?: boolean;
  $isRCPortal?: boolean;
  $isborderRight?: boolean;
  $isSelectCountry?: boolean;
}
const customWidth = (
  isRCPortal?: boolean,
  isRemoteJobsPage?: boolean,
  isHeader?: boolean
) => {
  let widthValue;

  if (isRCPortal) {
    widthValue = isRemoteJobsPage ? '58.5%' : '47%';
  } else {
    widthValue = !isHeader && '100%';
  }
  return widthValue;
};
/* width: ${//customWidth(isRCPortal, isRemoteJobsPage, isHeader)}; //FOR BASELINE will remove once exeriment win. */
export const Styledform = styled.form``;
export const SearchFilterBlock = styled.div`
  margin-top: -2.4rem;
  padding-right: 0.4rem;
  ${({ theme: { SearchFilterStyle } }) => {
    return (
      SearchFilterStyle &&
      css`
        background-color: ${SearchFilterStyle?.['white'] || color('white')};
        ${device.desktopMini} {
          margin-top: -3.5rem;
          box-shadow: 0 0.2rem 1.6rem 0
            ${SearchFilterStyle?.['box-shadow'] || color('box-shadow')};
          position: relative;
          z-index: 3;
          border: 0.1rem solid
            ${SearchFilterStyle?.['color-9'] || color('color-9')};
        }
      `
    );
  }}
  .mobilefilterbtn {
    margin: 1.5rem 0 1.6rem;
    width: 100%;
    padding: 0.62em 1rem;
    font-size: 1.2rem;
    font-weight: 400;
    background-color: ${color('white')};
    color: ${color('color-1')};
    border: 0.1rem solid ${color('color-1')};
    border-radius: 0.4rem;
    cursor: pointer;
    text-align: center;
    line-height: 1;
    display: inline-block;
  }
  .mobilefilterbtn.primary {
    background-color: ${color('color-1')};
    color: ${color('white')};
  }
  .mobilefilterbtn:not(.close-btn) .fa-sliders {
    margin-right: 0.5rem;
  }
`;
export const InputSearch = styled.input<InputSearchProp>`
  padding: 0.8rem 1.6rem;
  outline: none;
  ${({
    theme: { SearchFilterStyle },
    $inputHeight,
    $isHeader,
    $borderRight,
    $isSelectCountry,
  }) =>
    SearchFilterStyle &&
    css`
      border-radius: ${!$borderRight && '0.4rem'};
      background-color: ${$isHeader
        ? SearchFilterStyle.BgColors.headerSearch
        : SearchFilterStyle.BgColors.search};
      border: 0.1rem solid
        ${$isHeader
          ? SearchFilterStyle.BdrColors.transSearch
          : SearchFilterStyle.BdrColors.searchWrap};
      &::placeholder {
        color: ${SearchFilterStyle.Colors.searchWrap};
      }
      height: ${$inputHeight || '4.2rem'};

      ${device.mobileLg} {
        font-size: ${fontSize('xs')};
      }
      &::placeholder {
        color: ${SearchFilterStyle?.['color-10'] ||
        color('color-10')}!important;
        opacity: 1;
      }

      ${$isSelectCountry &&
      css`
        &:first-child {
          border-radius: 0;
        }
      `}

      ${device.mobileTab} {
        background-color: ${SearchFilterStyle.BgColors.mbSearch};
      }
    `}
`;

export const SearchWrap = styled.div<{
  $isHeader?: boolean;
  $isMobileHidden?: boolean;
  $isSelectedCountry?: boolean;
}>`
  display: grid;
  grid-template-columns: ${({ $isSelectedCountry }) =>
    $isSelectedCountry ? '1fr 1fr 1fr 3.2rem' : '1fr 1fr 3.2rem'};
  align-items: center;
  ${({ theme: { SearchFilterStyle } }) =>
    SearchFilterStyle &&
    css`
      border: 0.1rem solid ${SearchFilterStyle?.['color-9'] || color('color-9')};
    `}
  ${device.tabletMd} {
    grid-template-columns: ${({ $isSelectedCountry }) =>
      $isSelectedCountry ? '1fr 1fr 1fr 7.2rem' : '1fr 1fr 8.2rem'};
  }

  ${device.desktopMini} {
    grid-template-columns: ${({ $isSelectedCountry }) =>
      $isSelectedCountry
        ? '1fr 1fr 1fr 11.3rem 4.4rem'
        : '1fr 1fr 11.3rem 4.4rem'};
    max-width: 99.9%;
    border: 0;
    padding-right: 1.7rem;
  }

  ${({ theme: { SearchFilterStyle }, $isHeader }) =>
    SearchFilterStyle &&
    css`
      box-shadow: ${$isHeader &&
      `0 0.3rem 0.6rem ${SearchFilterStyle.BdrColors.searchWrapShadow}`};
    `}

  ${device.mobileTab} {
    box-shadow: none;
    justify-content: center;
  }
  ${({ $isMobileHidden }) =>
    $isMobileHidden &&
    css`
      ${device.mobileLg} {
        display: none;
      }
    `}
`;

export const InputWrap = styled.div<{
  $isHeader?: boolean;
  $isJobTitleBox?: boolean;
}>`
  width: ${({ $isHeader }) => ($isHeader ? '28.5rem' : '100%')};
  flex-grow: 1;

  position: relative;
  input,
  select {
    border: 0;
    border-radius: 0;
    background: transparent;
    padding-left: 4rem;
    ${device.tabletMd} {
      padding-left: 2.5rem;
    }
  }
  ${({ theme: { SearchFilterStyle }, $isJobTitleBox }) =>
    $isJobTitleBox &&
    css`
      &:after {
        content: '';
        ${MixinStyle.PositionStyle('50%', 0, null, null)};
        height: 3.2rem;
        width: 0.2rem;
        margin-top: -1.6rem;
        background-color: ${SearchFilterStyle?.['color-9'] || color('color-9')};
      }
    `}
`;

export const Wrap = styled.div`
  position: relative;
`;

export const SearchResultWrap = styled.div<{
  $isSearchJobsResultWrap?: boolean;
}>`
  ${MixinStyle.PositionStyle('100% ', null, null, '0.1rem')};
  z-index: 10;
  width: 100%;
  ${({ theme: { SearchFilterStyle }, $isSearchJobsResultWrap }) =>
    SearchFilterStyle &&
    css`
      background-color: ${SearchFilterStyle.BgColors.searchResultWrap};
      border: 0.1rem solid ${SearchFilterStyle.BdrColors.searchResultWrapBrdr};
      border-top: 0;
      ${device.mobileLg} {
        width: ${$isSearchJobsResultWrap ? '56vw' : null};
      }
    `}
`;

export const ResultListWrap = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  .light-font {
    font-weight: 400;
  }
`;

export const StaticListWrap = styled.li<{
  $bdrbottom?: boolean;
  $extraTopSpace?: boolean;
  $extraBottomSpace?: boolean;
  isAddStaticSearchList?: boolean;
}>`
  padding: 0.5rem 1rem;
  ${({ theme: { SearchFilterStyle }, $bdrbottom }) =>
    SearchFilterStyle &&
    $bdrbottom &&
    css`
      border-bottom: ${$bdrbottom &&
      `0.1rem solid ${SearchFilterStyle.BdrColors.staticListBrdr}`};
    `}
  padding-top: ${({ $extraTopSpace }) => $extraTopSpace && '1rem'};
  padding-bottom: ${({ $extraBottomSpace }) => $extraBottomSpace && '1rem'};
`;

export const ListItem = styled.li<{
  $highlightIndex?: any;
  isExpSavedSearchDropDown?: boolean;
  isHovered?: boolean;
}>`
  padding: ${({ isExpSavedSearchDropDown }) =>
    isExpSavedSearchDropDown ? '0.8rem 2rem 0.8rem 5.2rem' : '0.8rem 2rem'};

  ${({ theme: { SearchFilterStyle }, $highlightIndex, isHovered }) =>
    SearchFilterStyle &&
    css`
      color: ${isHovered
        ? '#fff'
        : $highlightIndex && SearchFilterStyle.Colors.resultHighlight};
      background-color: ${isHovered
        ? '#00A2E1'
        : $highlightIndex
        ? SearchFilterStyle.BgColors.resultHighlight
        : SearchFilterStyle.BgColors.listItemBg};

      &:hover,
      &:focus {
        color: ${SearchFilterStyle.Colors.resultHighlight};
        background-color: ${SearchFilterStyle.BgColors.resultHighlight};
        cursor: pointer;
      }
    `}
  ${device.mobileLg} {
    padding: 0.5rem 1rem;
    ${({ theme: { SearchFilterStyle } }) =>
      SearchFilterStyle &&
      css`
        font-size: ${SearchFilterStyle?.FontSizes?.listItem};
      `};
  }
`;

export const SearchBtn = styled.button<{
  $isHeader?: boolean;
  $isSearchFilter?: boolean;
  $isRCPortal?: boolean;
  $themeType?: boolean;
}>`
  border: none;
  flex-shrink: 0;
  padding: 0 1.2rem;
  cursor: pointer;
  svg {
    fill: ${({ theme: { SearchFilterStyle } }) =>
      (SearchFilterStyle && SearchFilterStyle?.['white']) || color('white')};
    transform: scale(0.625);
    ${device.mediumScreen} {
      transform: scale(0.625);
    }
  }
  ${({ theme: { SearchFilterStyle }, $isHeader, $isRCPortal, $themeType }) =>
    SearchFilterStyle &&
    css`
      border-top-right-radius: ${SearchFilterStyle.BdrLeftAdnRight
        .searchButton};
      border-bottom-right-radius: ${SearchFilterStyle.BdrLeftAdnRight
        .searchButton};
      border-radius: 0.4rem;
      color: ${color('white')};
      background-color: ${$themeType ? color('color-1') : color('black')};
      font-size: ${fontSize('sm')};

      border: 0.1rem solid
        ${$isHeader
          ? SearchFilterStyle.BdrColors.transSearch
          : SearchFilterStyle.BdrColors.searchBtnWrap};
      &:focus {
        outline-offset: 0;
      }
      ${$isRCPortal &&
      css`
        &:hover {
          background: ${SearchFilterStyle?.BgColors?.searchButtonHover};
          color: ${SearchFilterStyle?.Colors?.searchButtonHover};
        }
      `}
    `}
  ${device.mobileTab} {
    padding: 0.6rem 0.7rem;
    border-radius: 0 0.3rem 0.3rem 0;
  }

  ${Mixin.AllCenter({ align: 'center', justify: 'center' })}
  height: 4rem;
  margin-left: 2.4rem;
  ${device.tabletMd} {
    margin-right: 0.4rem;
    height: 3.2rem;
  }
`;

export const SearchHeading = styled.li<{ isExpSavedSearchDropDown?: boolean }>`
  cursor: default;
  padding: 0.8rem 1.6rem 0.8rem 2rem;
  ${({ theme: { SearchFilterStyle }, isExpSavedSearchDropDown }) =>
    SearchFilterStyle &&
    css`
      color: ${SearchFilterStyle.Colors.searchHead};
      border-bottom: ${!isExpSavedSearchDropDown
        ? '0.1rem solid ' + SearchFilterStyle.BdrColors.searchHeadBrdr
        : null};
      position: ${isExpSavedSearchDropDown ? 'relative' : null};
      padding-left: ${isExpSavedSearchDropDown ? '5.2rem' : null};
      text-transform: ${isExpSavedSearchDropDown ? null : 'uppercase'};
    `}
`;

//EXPERIMENT CHANGES RM-1105
export const StaticListWrapExp = styled.li<{
  isAddStaticSearchList?: boolean;
}>`
  padding: 0 0.8rem;
  img {
    width: 1.7rem;
    margin-right: 0.8rem;
  }
  .link-icon {
    margin-right: 0.8rem;
  }
  a {
    color: #212529;
    padding: 0.8rem 0 0.8rem 1.6rem;
    display: block;
    ${device.mobileLg} {
      padding: 0.5rem;
      font-size: 1.4rem;
    }
  }
  &:first-child a,
  &:nth-child(3) a {
    border-bottom: 0.1rem solid #919397;
  }
`;

export const InputIcon = styled.i`
  ${MixinStyle.PositionStyle('50%', null, null, '1.5rem')};
  transform: translateY(-50%);
  font-size: 1.6rem;
  color: #646f82;
  pointer-events: none;
  ${device.tabletMd} {
    font-size: 1.4rem;
    left: 0.8rem;
  }
`;
export const FilterBtn = styled.button`
  background: none;
  border: 0;
  padding: 0;
  min-width: 4.4rem;
  min-height: 4.4rem;
  font-size: 2rem;
  margin-left: 0.8rem;
  border-radius: 0.4rem;
  &:focus {
    outline-offset: 0;
  }
  &:hover {
    background-color: ${color('color-16')};
    color: ${color('color-24')};
  }
`;
export const FilterSection = styled.div`
  ${device.desktopMini} {
    padding: 1.6rem 2rem;
    border-top: 0.1rem solid #d9dadb;
  }
`;

//isExpSavedSearchDropDown
const jobsIcon = `data:image/svg+xml,%3Csvg%20width%3D%2222%22%20height%3D%2222%22%20viewBox%3D%220%200%2022%2022%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M1%206H21V21H1V6Z%22%20fill%3D%22%23C7EFFF%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M1%206H21V21H1V6Z%22%20stroke%3D%22%23006EA5%22%20strokewidth%3D%222%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M1%2011H21%22%20stroke%3D%22%23006EA5%22%20strokewidth%3D%222%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M11%2011V14%22%20stroke%3D%22%23006EA5%22%20strokewidth%3D%222%22%3E%3C%2Fpath%3E%3Cpath%20d%3D%22M16%206C16%203.23858%2013.7614%201%2011%201C8.23858%201%206%203.23858%206%206%22%20stroke%3D%22%23006EA5%22%20strokewidth%3D%222%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E`;
const categoryIcon = `data:image/svg+xml,%3Csvg%20width%3D%2223%22%20height%3D%2223%22%20viewBox%3D%220%200%2023%2023%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M1%201H9V6.33233C7.92609%207.01348%207.01348%207.92609%206.33233%209H1V1Z%22%20fill%3D%22%23C7EFFF%22%2F%3E%3Cpath%20d%3D%22M20.8677%209H21V1H13V5.0206C13.1982%205.00694%2013.3983%205%2013.6%205C16.6577%205%2019.3428%206.5958%2020.8677%209Z%22%20fill%3D%22%23C7EFFF%22%2F%3E%3Cpath%20d%3D%22M5.0206%2013H1V21H9V20.8676C6.5958%2019.3427%205%2016.6577%205%2013.6C5%2013.3983%205.00694%2013.1982%205.0206%2013Z%22%20fill%3D%22%23C7EFFF%22%2F%3E%3Cpath%20d%3D%22M19.2%2013.6C19.2%2016.6928%2016.6928%2019.2%2013.6%2019.2C10.5072%2019.2%208%2016.6928%208%2013.6C8%2010.5072%2010.5072%208%2013.6%208C16.6928%208%2019.2%2010.5072%2019.2%2013.6Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M19.2%2013.6C19.2%2016.6928%2016.6928%2019.2%2013.6%2019.2C10.5072%2019.2%208%2016.6928%208%2013.6C8%2010.5072%2010.5072%208%2013.6%208C16.6928%208%2019.2%2010.5072%2019.2%2013.6Z%22%20stroke%3D%22%23006EA5%22%20stroke-width%3D%222%22%2F%3E%3Cpath%20d%3D%22M21.9998%2021.9998L17.5596%2017.5596%22%20stroke%3D%22%23006EA5%22%20stroke-width%3D%222%22%2F%3E%3Cpath%20d%3D%22M9%205V1H1V9H5%22%20stroke%3D%22%23006EA5%22%20stroke-width%3D%222%22%2F%3E%3Cpath%20d%3D%22M9%2021H1V13H5%22%20stroke%3D%22%23006EA5%22%20stroke-width%3D%222%22%2F%3E%3Cpath%20d%3D%22M21%208V1H13V5%22%20stroke%3D%22%23006EA5%22%20stroke-width%3D%222%22%2F%3E%3C%2Fsvg%3E`;
const recentSearchagesIcon = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiIGZpbGw9IiNDN0VGRkYiLz4KPHBhdGggZD0iTTEwIDBDMTUuNTIyOCAwIDIwIDQuNDc3MTUgMjAgMTBDMjAgMTUuNTIyOCAxNS41MjI4IDIwIDEwIDIwQzQuODE0NjcgMjAgMC41NTE1NSAxNi4wNTMzIDAuMDQ5Nzk5OSAxMUgyLjA2NDQ1QzIuNTU2NjkgMTQuOTQ2MiA1LjkyMDQ5IDE4IDEwIDE4QzE0LjQxODMgMTggMTggMTQuNDE4MyAxOCAxMEMxOCA1LjU4MTcyIDE0LjQxODMgMiAxMCAyQzcuMDQwMzYgMiA0LjQ1NTk4IDMuNjA4NDQgMy4wNzIyNyA2SDYuNVY4SDBWMS41SDJWNEMzLjgyMzkzIDEuNTcxNzYgNi43Mjc2MiAwIDEwIDBaTTExIDkuNTg1OUwxNC43MDcgMTMuMjkzTDEzLjI5MyAxNC43MDdMOSAxMC40MTQxVjVIMTFWOS41ODU5WiIgZmlsbD0iIzAwNkVBNSIvPgo8L3N2Zz4K`;

const getDropdownIcon = ({
  isCategoryIcon,
  isRecentSearches,
}: {
  isCategoryIcon?: boolean;
  isRecentSearches?: boolean;
}) => {
  if (isRecentSearches) return recentSearchagesIcon;
  if (isCategoryIcon) return categoryIcon;
  return jobsIcon;
};

export const DropdownIcon = styled.span<{
  isCategoryIcon?: boolean;
  isRecentSearches?: boolean;
}>`
  content: '';
  background-image: ${({ isCategoryIcon, isRecentSearches }) =>
    `url(${getDropdownIcon({ isCategoryIcon, isRecentSearches })})`};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  width: 2.4rem;
  height: 2.4rem;
  margin: auto;
  ${MixinStyle.PositionStyle('0', 'auto', '0', '2rem')};
`;
